import { Injectable } from "@angular/core";
import { GenericEntityService } from "../../../core.utilidades/generic-entity.service";
import { Poliza } from "../../../app.domain.models/poliza";
import { PolizaRepository } from "../domain.repositories/poliza.repository";

@Injectable({
    providedIn: 'root',
})
export class PolizaApiService extends PolizaRepository implements GenericEntityService<Poliza> { }